//Code d'erreur Http
enum HttpStatusCode {
	NotAuthorized = 401,
	NotFound = 404,
	SessionExpired = 440,
	InternalServerError = 500,
}

enum dialogTypes {
	msg = 1,
	alert = 2,
	custom = 3,
}

enum formulaireEnum {
	cellSouches = 0,
	sangCordon = 1,
	laitMaternel = 2,
	adresse = 3,
	education = 4,
	recherche = 5,
	benevoles = 6,
	demandeRenseignements = 7,
	materielSangCordon = 8,
	suiviPostGreffeAutologue = 9,
	suiviPostGreffeAutologueCH = 10,
}

export { HttpStatusCode, dialogTypes, formulaireEnum };
